import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromTeams from '../reducers/teams.reducer';
export const selectTeamsState = createFeatureSelector<fromTeams.State>('teams');
export const selectTeams = createSelector(
  selectTeamsState,
  (state: fromTeams.State) => state.teams
);
export const selectTeamsErrorMessage = createSelector(
  selectTeamsState,
  (state: fromTeams.State) => state.errorMessage
);
export const selectIsTeamsLoading = createSelector(
    selectTeamsState,
    (state: fromTeams.State) => state.isLoading 
)